export default __webpack_public_path__ + "static/media/logo.3755f99c.svg";